export default "<p style=\"margin: 40px; text-align: center;\">{{'Redirecting' | translate}}...</p>\n"